module.exports = __webpack_public_path__ + "static/Muli-BlackItalic.f7c309cf.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/muli/Muli-BlackItalic.ttf
// module id = 329
// module chunks = 114276838955818